/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/jsx-filename-extension */
import { TableCell, TableRow } from "@mui/material";
import moment from "moment";
import Typography from "../../../../components/common/new/Typography/Typography";

const styles = {
  tableRowCell: {
    borderBottom: "1px solid #BFCFE1",
    textAlign: "center",
  },
  status: {
    backgroundColor: "#E8FFDB",
    border: "1px solid #1C9C29",
    borderRadius: 12,
    padding: "2px 12px",
  },
};

export const MAX_SIZE = 5;

export const TABLE_TYPE = {
  ATTENDANCE: "ATTENDANCE",
};
export const ROW_LIMIT = {
  [TABLE_TYPE.SUBS]: 3,
  [TABLE_TYPE.FAMILY]: 3,
  [TABLE_TYPE.APPOINTMENT]: 2,
  [TABLE_TYPE.ATTENDANCE]: 5,
  [TABLE_TYPE.UIN]: 5,
  [TABLE_TYPE.SPECIAL]: 5,
};

export const FLEX_CONTAINER = [TABLE_TYPE.ATTENDANCE];

export const getMaxRow = (data) =>
  Object.keys(data).reduce((acc, key) => {
    const { rows } = data[key];
    return rows.length > acc ? rows.length : acc;
  }, 0);

const MeetingTypesMap = {
  DISCUSSION_MEETING: "discussionMeeting",
  SPECIAL_MEETING: "specialMeeting",
  GOSHO_MEETING: "goshoMeeting",
};

export const getFormattedFriends = (data) => {
  if (!data || !data.length) return [];

  return [];
};

const getRowData = (curr) => {
  const date = moment(curr.meeting.meetingDate);
  return {
    id: curr.id,
    month: date.format("MMMM"),
    year: date.format("YYYY"),
  };
};

export const getFormattedData = (data) => {
  if (!data || !data.length) return {};

  return data.reduce(
    (acc, curr) => {
      const key = MeetingTypesMap[curr.meeting.meetingType];
      const currentRows = acc[key].rows;

      return {
        ...acc,
        [key]: {
          ...acc[key],
          rows: [...currentRows, getRowData(curr)],
        },
      };
    },
    {
      discussionMeeting: { title: "Discussion Meeting", rows: [] },
      specialMeeting: { title: "Special Meeting", rows: [] },
      goshoMeeting: { title: "Gosho Meeting", rows: [] },
      NHRMeeting: { title: "NHR Meeting", rows: [] },
      FDMeeting: { title: "FD Meeting", rows: [] },
      cubMeeting: { title: "Cub Meeting", rows: [] },
    }
  );
};

export const getAttendanceRows = (data, limit = ROW_LIMIT.ATTENDANCE) => {
  if (!data || !data.length) {
    return (
      <TableRow>
        <TableCell colSpan={4} align="center">
          <Typography weight={600} variant="small" color="#000000">
            No data available
          </Typography>
        </TableCell>
      </TableRow>
    );
  }
  return data?.slice(0, limit)?.map((attendance) => {
    return (
      <TableRow>
        <TableCell width="50%" style={styles.tableRowCell}>
          <Typography weight={500} variant="mini" color="#8C8C8C">
            {attendance.month}
          </Typography>
        </TableCell>
        <TableCell align="center" width="50%" style={styles.tableRowCell}>
          <Typography variant="mini" color="#183053">
            {attendance.year}
          </Typography>
        </TableCell>
      </TableRow>
    );
  });
};

export const getFullAttendanceRows = (data) =>
  data?.map((attendance) => {
    return (
      <TableRow>
        <TableCell width="50%" style={styles.tableRowCell}>
          <Typography weight={500} variant="mini" color="#8C8C8C">
            {attendance.month}
          </Typography>
        </TableCell>
        <TableCell align="center" width="50%" style={styles.tableRowCell}>
          <Typography variant="mini" color="#183053">
            {attendance.year}
          </Typography>
        </TableCell>
      </TableRow>
    );
  });
